module.exports = __webpack_public_path__ + "media/images/emblems/Waldkirch-blazono-99dbb0f42b61731a362f8e9a8e11ba6e.png";